import "./home.less"

const topNav = document.querySelector('.top-nav');
const hamburger = document.querySelector(".top-nav .hamburger");
if (!!hamburger && !!topNav) {
  document.addEventListener('click', (e) => {
    if (!topNav.contains(e.target as Node)) {
      topNav.classList.remove('open');
    }
  })

  hamburger.addEventListener('click', () => {
    topNav.classList.toggle('open');
  })
}

const testimonials = document.querySelectorAll('.testimonials li');
const testimonialNext = document.querySelector('.testimonials .next');
const testimonialPrev = document.querySelector('.testimonials .prev');

function findActiveTestimonial(items: NodeListOf<Element>) {
  let result = -1;
  items.forEach((item, idx) => {
    if (item.classList.contains("active")) {
      result = idx;
    }
  });
  return result;
}

function setActiveTestimonialIndex(items: NodeListOf<Element>, newActiveIdx: number) {
  items.forEach((item, itemIdx) => {
    if (itemIdx !== newActiveIdx) {
      item.classList.remove("active");
    } else {
      item.classList.add("active");
    }
  })
}

if (testimonials.length > 0 && !!testimonialNext && !!testimonialPrev) {
  
  let initiallyActive = findActiveTestimonial(testimonials);
  if (initiallyActive === -1) {
    testimonials[0].classList.add("active");
  }

  testimonialNext.addEventListener('click', () => {
    let idx = findActiveTestimonial(testimonials);
    if (idx === -1) {
      idx = 0;
    } else {
      idx = (idx + 1) % testimonials.length;
    }

    setActiveTestimonialIndex(testimonials, idx);
  });

  testimonialPrev.addEventListener('click', () => {
    let idx = findActiveTestimonial(testimonials);
    if (idx === -1) {
      idx = 0;
    } else {
      idx--;
      if (idx < 0) idx = testimonials.length - 1;
    }

    setActiveTestimonialIndex(testimonials, idx);
  });
}
